import React from "react";
import "./Admissions.css";
import { FiPhone } from "react-icons/fi";
import { HiOutlineClock, HiOutlineLocationMarker } from "react-icons/hi";

const Admissions = () => {
  return (
    <div className="admissions">
      <h2 className="admissions-title">For Admissions & Enquiries</h2>
      <p className="admissions-subtitle">Visit the training center</p>

      <div className="admissions-container">

        {/* LEFT CARD */}
        <div className="admissions-card">
          <h3>PRT Academy Software Training Center</h3>

          <p className="address">
            Plot No.142. Third floor, Balaji commercial complex, Bhagyanagar colony, KPHB-HYD-500072.
          </p>

          <div className="info">
            <div className="info-item">
              <FiPhone className="icon" />
              <span>9398219604</span>
            </div>

            <div className="info-item">
              <HiOutlineClock className="icon" />
              <span>9:00AM - 9:00PM</span>
            </div>
          </div>

          <hr className="divider" />

          <button
            className="btn"
            onClick={() =>
              window.open(
                `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                  "Plot No.142, Third Floor, Balaji Commercial Complex, Bhagyanagar Colony, KPHB, Hyderabad, Telangana 500072"
                )}`,
                "_blank"
              )
            }
          >
            <HiOutlineLocationMarker className="location-icon" />
            Directions
          </button>
        </div>

        {/* MAP */}
        <div className="map">
          <iframe
            src={`https://www.google.com/maps?q=${encodeURIComponent(
              "Plot No.142, Third Floor, Balaji Commercial Complex, Bhagyanagar Colony, KPHB, Hyderabad, Telangana 500072"
            )}&output=embed`}
            title="map"
            loading="lazy"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default Admissions;